<!--
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-ly-tag-fields">
    <template v-if="fieldType === 3 || fieldType === 5">
      <!-- 多选 -->
      <!-- 列表 -->
      <xl-table-popover :styleInfo="props.styleInfo" :value="newFieldValue" />
    </template>

    <template v-else>
      <template v-if="fieldKey == 'entityType'">
        <template v-if="record?.DYNAMIC_RECORD_RELATION?.fieldValue || record?.dynamicRecordEntityRelation">
          <jw-tooltip position="top" mini :content="record?.dynamicRecordEntityRelation == 'cancel' || record?.DYNAMIC_RECORD_RELATION?.fieldValue == 'cancel' ? data.text1 : data.text2" :content-style="{ borderRadius: '4px' }">
            <span class="text-delete-through-line ellipsis-content">{{ newFieldValue || '-' }}</span>
          </jw-tooltip>
        </template>
        <template v-else>
          <span class="ellipsis-content">{{ newFieldValue || '-' }}</span>
        </template>
      </template>
      <template v-else>
        <template v-if="newFieldValue">
          <jw-tag size="small" class="jw-tag-style-nowrap" :color="getTagStyle(newFieldValue)?.background || 'var(--color-fill-2)'" :style="{ color: getTagStyle(newFieldValue)?.color || 'var(--color-text-1)' }">
            <fh-ellipsis :content="newFieldValue" />
          </jw-tag>
        </template>
        <template v-else>-</template>
      </template>
    </template>
  </div>
</template>

<script setup>
import { computed, reactive } from 'vue';
import { tools } from '@/utils/tools';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';

//import { reactive, ref } from 'vue';

// const data = reactive({});
// const name = ref();
const props = defineProps({
  fieldValue: {
    type: Object || String || Number,
    default: ''
  },
  fieldName: {
    type: String,
    default: ''
  },
  fieldKey: {
    type: String,
    default: ''
  },
  mainField: {
    type: Boolean,
    default: false
  },
  styleInfo: {
    type: Object,
    default: () => {}
  },
  record: {
    type: Object,
    default: () => {}
  },
  fieldType: {
    type: Number
  },
  displayOneLine: {
    //布局 0：1/2行  1：整行 2:1/3行 3:2/3行
    type: Number,
    default: 0
  },
  isList: {
    type: Boolean,
    default: false
  }
});
const data = reactive({
  text1: `"来源数据类型"已被管理员取消了关联关系`,
  text2: `"来源数据类型"的选项来源已被管理员停用了`
});

const newFieldValue = computed(() => props.fieldValue);

const textTagStyle = computed(() => (tools.isJSON(props.styleInfo) ? JSON.parse(props.styleInfo) : null));
const fieldType = computed(() => props.fieldType);

const getTagStyle = (label) => {
  return Array.isArray(textTagStyle.value) && textTagStyle.value?.find((styleItem) => styleItem.label === label);
};

// console.log(data, name);
</script>
<style scoped lang="less">
@import './ly-tag-fields.less';
</style>
